import React, { Component } from 'react';
import './ThankYou.scss';
import PrimaryButton from '../Component/PrimaryButton';
import history from '../History';
import { formatAsCurrency } from '../Helper';
import ForScreen from '../Containers/ForScreen';

let DirectDonation = props => {
  let fulfilment = props.fulfilment;
  let child = props.child;
  let listnameGen =
    child.listname.slice(-1) === 's' ? child.listname : child.listname + 's';
  let gender = child.gender === 'male' ? 'männlich' : 'weiblich';
  return (
    <div className="col-md-8 col-md-offset-2 text-md-center text-lg-center">
      <p>
        Sie haben sich dazu entschlossen, für {listnameGen} ({child.age},{' '}
        {gender}) {fulfilment.wish.label} zu spenden.
      </p>

      <p className="payment-details">
        {' '}
        Wunschnummer: <strong>{fulfilment.reference}</strong>
      </p>

      <p>
        <strong>Hinweis:</strong> Bitte notieren Sie diese Wunschnummer
        unbedingt auf dem Geschenk. Denn nur mit dieser Nummer kann das Geschenk
        dem entsprechenden Kind eindeutig zugeordenet werden.
      </p>
      <p>
        Sollten Sie eine Spendebescheinigung benötigen, brauchen wir den
        Kassenbon bzw. die Rechnung des Geschenkes und Ihre Auschrift.
      </p>
    </div>
  );
};

let NormalDonation = props => {
  let fulfilment = props.fulfilment;
  let child = props.child;
  let listnameGen =
    child.listname.slice(-1) === 's' ? child.listname : child.listname + 's';
  let gender = child.gender === 'male' ? 'männlich' : 'weiblich';
  return (
    <div>
      <div className="col-md-8 col-md-offset-2 text-md-center text-lg-center">
        <p>
          Sie haben sich dazu entschlossen,{' '}
          {formatAsCurrency(fulfilment.amount)} € für {listnameGen} ({child.age}
          , {gender}) {fulfilment.wish.label} zu spenden.
        </p>
        <p>
          {child.gender === 'male' ? 'Er' : 'Sie'} könnte nicht glücklicher mit
          dem Geschenk sein!
        </p>
        <p>Bitte nutzen Sie die folgenden Informationen zum Spenden:</p>
      </div>
      <div className="col-md-6 col-md-offset-3 col-sm-10 col-sm-offset-1">
        <ForScreen desktop>
          <dl className="dl-horizontal">
            <dt>Kontoinhaber</dt>
            <dd>Südstadt Leben e.V.</dd>
            <dt>Betrag</dt>
            <dd>{formatAsCurrency(fulfilment.amount)}€</dd>
            <dt>IBAN</dt>
            <dd>DE43 3506 0190 1013 4760 86</dd>
            <dt>Verwendungszweck:</dt>
            <dd>
              Weihnachtswunschaktion{' '}
              {
                //fulfilment.reference
              }
            </dd>
            <dt>BIC:</dt>
            <dd>GENODED1DKD</dd>
            <dt>Bank:</dt>
            <dd>Bank für Kirche und Diakonie</dd>
          </dl>
        </ForScreen>
        <ForScreen mobile>
          <div className="payment-details">
            <p>
              Kontoinhaber: <strong>Südstadt Leben e.V.</strong>
              <br />
              Betrag: <strong>{formatAsCurrency(fulfilment.amount)}€</strong>
              <br />
              IBAN: <strong>DE43 3506 0190 1013 4760 86</strong>
              <br />
              Verwendungszweck: <strong>Weihnachtswunschaktion</strong>
              {
                //fulfilment.reference
              }
              <br />
              BIC: <strong>GENODED1DKD</strong>
              <br />
              Bank: <strong>Bank für Kirche und Diakonie</strong>
            </p>
          </div>
        </ForScreen>
      </div>
      <div className="col-sm-8 col-sm-offset-2 text-md-center text-lg-center">
        <p>
          <strong>
            Sie erhalten alle notwendigen Informationen ebenfalls per E-Mail.
          </strong>
        </p>
      </div>
    </div>
  );
};

class ThankYou extends Component {
  headline = 'Vielen Dank für Ihre Spende!';

  componentDidMount() {
    // if there is no data passed to the thank you screen, we will redirect to home
    if (
      !this.props.location.state ||
      !this.props.location.state.fulfilment ||
      !this.props.location.state.child
    ) {
      history.push({
        pathname: '/'
      });
    }
  }

  render() {
    if (
      !this.props.location.state ||
      !this.props.location.state.fulfilment ||
      !this.props.location.state.child
    ) {
      return null;
    }

    let fulfilment = this.props.location.state.fulfilment;
    let child = this.props.location.state.child;

    return (
      <div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1 text-md-center text-lg-center header">
            <h2 className="section-header">{this.headline}</h2>
          </div>
        </div>
        <div className="row">
          {this.props.location.state.fulfilment.wish.purchase === 'direct' ? (
            <DirectDonation fulfilment={fulfilment} child={child} />
          ) : (
            <NormalDonation fulfilment={fulfilment} child={child} />
          )}
        </div>
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center child-happy-section">
            <PrimaryButton
              to={'/list'}
              size={'lg'}
              title={'NOCHMAL SPENDEN!'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ThankYou;



// WEBPACK FOOTER //
// ./src/Containers/ThankYou.js